import { Input } from "antd";

export default function CpfInput({ onChange, value, ...props }) {
  const shownValue = value ? value.replace(/\D/g, "") : value;

  const handleChange = (e) => onChange(e.target.value.replace(/\D/g, ""));
  return <Input value={shownValue} onChange={handleChange} {...props} />;
}
